function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var UIModTemplate = require('./../../../templates/uimodtemplate');
var SaitoHeaderTemplate = require('./saito-header.template');
var FloatingMenu = require('./saito-floating-menu.template');
var SaitoOverlay = require('./../saito-overlay/saito-overlay');
var SaitoLoader = require('./../saito-loader/saito-loader');
var UserMenu = require('./../modals/user-menu/user-menu');
var SaitoBackup = require('./../modals/saito-backup/saito-backup');
var SelectNFT = require('./../saito-nft/overlays/select-nft-overlay');

//
// UIModTemplate
//
// The header derives from UIModTemplate -- this allows the component
// to be added to the list of modules that are actively running on Saito
// thus allowing them to receive transactions and update their UI just
// like any other modules.
//

//
// Note: inherits this.publicKey from modtemplate
//
var SaitoHeader = /*#__PURE__*/function (_UIModTemplate) {
  function SaitoHeader(app, mod) {
    var _this;
    _classCallCheck(this, SaitoHeader);
    _this = _callSuper(this, SaitoHeader, [app]);

    //
    // UI components as modules allows them to respond
    // to events individually...
    //
    _this.name = 'SaitoHeader UIComponent';
    _this.slug = 'SaitoHeader';
    _this.app = app;
    _this.mod = mod;

    // employ non-standard css to spacing in header
    _this.header_class = ''; // e.g. game, wide-screen, arcade

    // Header collects notifications to display a count on the hamburger icon
    _this.notifications = {};

    // navigation for clicking on Saito logo in header
    _this.header_location = '/' + mod.returnSlug();

    // Store the mod functions for when you click icon in the menu, e.g. "RedSquare"
    _this.callbacks = {};
    _this.web3_start_polling_timeout = null;
    _this.can_update_header_msg = true;
    _this.show_msg = true;
    _this.back_button_callback = null;
    _this.loader = new SaitoLoader(_this.app, _this.mod, '#qrcode');
    _this.saito_backup = new SaitoBackup(app, mod);

    // listens for events
    _this.select_nft_overlay = new SelectNFT(app, mod);
    console.log('Create Saito Header for ' + mod.name);
    return _this;
  }
  _inherits(SaitoHeader, _UIModTemplate);
  return _createClass(SaitoHeader, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app) {
        var _this2 = this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _superPropGet(SaitoHeader, "initialize", this, 3)([app]);
            case 1:
              //
              // initialized here because we need our publickey
              //
              this.userMenu = new UserMenu(app, this.publicKey);

              //
              // registry
              //
              app.connection.on('registry-update-identifier', function (publicKey) {
                if (publicKey === _this2.publicKey) {
                  _this2.renderUsername();
                }
              });

              //
              // listen for inbound / outbound payments
              //
              app.connection.on('on-transaction-pending', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var obj,
                  _args = arguments;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      obj = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                      if (!_this2.installing_crypto) {
                        _this2.renderCrypto();
                      }
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              })));
              app.connection.on('wallet-updated', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var obj,
                  _args2 = arguments;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      obj = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                      if (!_this2.installing_crypto) {
                        _this2.renderCrypto();
                      }
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              app.connection.on('on-payment-sent', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                var obj,
                  _args3 = arguments;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      obj = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
                      if (!_this2.installing_crypto) {
                        _this2.renderCrypto();
                      }
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              })));
              app.connection.on('on-payment-received', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var obj,
                  amount,
                  ticker,
                  sender,
                  _args4 = arguments;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      obj = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
                      if (!_this2.installing_crypto) {
                        _this2.renderCrypto();
                      }
                      if (obj) {
                        _context4.n = 1;
                        break;
                      }
                      console.debug('on-payment-received -- no object');
                      return _context4.a(2);
                    case 1:
                      amount = obj.amount;
                      ticker = obj.ticker;
                      sender = obj.sender;
                      if (!(!amount || !ticker || !sender)) {
                        _context4.n = 2;
                        break;
                      }
                      return _context4.a(2);
                    case 2:
                      if (!(sender === _this2.publicKey)) {
                        _context4.n = 3;
                        break;
                      }
                      return _context4.a(2);
                    case 3:
                      siteMessage("".concat(amount, " ").concat(ticker, " inbound from ").concat(_this2.app.keychain.returnUsername(obj.sender)), 3000);
                    case 4:
                      return _context4.a(2);
                  }
                }, _callee4);
              })));
              app.connection.on('saito-header-update-message', function () {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var msg = '';
                var flash = false;
                var callback = null;
                var timeout = null;
                if (obj && _typeof(obj) === 'object') {
                  if ('msg' in obj) {
                    msg = obj.msg;
                  }
                  if ('flash' in obj) {
                    flash = obj.flash;
                  }
                  if ('callback' in obj) {
                    callback = obj.callback;
                  }
                  if ('timeout' in obj) {
                    timeout = obj.timeout;
                  }
                }
                _this2.can_update_header_msg = !('msg' in (obj || {}));
                _this2.updateHeaderMessage(msg, flash, callback, timeout);
              });
              app.connection.on('saito-header-install-crypto', function (ticker) {
                console.log('install crypto');
                _this2.installing_crypto = ticker;
                try {
                  var qrcode = document.querySelector('#qrcode');
                  var balance_amount = document.querySelector('.balance-amount');
                  var wallet_select = document.querySelector('#wallet-select-crypto');
                  if (qrcode) {
                    qrcode.innerHTML = '';
                  }
                  if (balance_amount) {
                    balance_amount.innerHTML = '';
                  }
                  if (wallet_select) {
                    wallet_select.innerHTML = "<option selected value=\"".concat(ticker, "\">").concat(ticker, "</option>");
                  }
                  var addressContainer = document.querySelector('#profile-public-key');
                  if (addressContainer) {
                    addressContainer.dataset.add = '';
                    addressContainer.innerHTML = '<div class="profile-public-key-text">generating keys...</div>';
                    addressContainer.classList.add('generate-keys');
                  }
                  _this2.loader.show();
                  siteMessage("Installing ".concat(ticker, " in Saito Multiwallet..."), 2000);
                } catch (err) {
                  console.error(err);
                }
              });
              app.connection.on('saito-crypto-activated', /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(ticker) {
                  var activated_mod;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        if (_this2.installing_crypto && _this2.installing_crypto == ticker) {
                          activated_mod = _this2.app.wallet.returnCryptoModuleByTicker(ticker);
                          if ((activated_mod === null || activated_mod === void 0 ? void 0 : activated_mod.categories) === 'NFT') {
                            _this2.installing_crypto = false;
                          } else {
                            setTimeout(function () {
                              _this2.installing_crypto = false;
                              _this2.app.connection.emit('saito-backup-render-request', {
                                msg: "Your wallet has added new crypto keys for ".concat(ticker, ". Unless you backup your wallet, you may lose any deposits with those keys.")
                              });
                            }, 1500);
                          }
                        }
                        _context5.n = 1;
                        return _this2.renderCrypto(true);
                      case 1:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }());

              //
              // This allows us to replace the saito logo with a back arrow and a click event
              // In the future, we may want to parameterize what we replace the logo with
              //
              app.connection.on('saito-header-replace-logo', function () {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                _this2.enableBackButton(callback);
              });
              app.connection.on('saito-header-change-location', function (new_path) {
                _this2.header_location = new_path;
              });
              app.connection.on('saito-header-render', function () {
                _this2.render();
              });
              app.connection.on('saito-header-reset-logo', function () {
                _this2.disableBackButton();
              });
              app.connection.on('saito-header-notification', function (source_mod, unread) {
                _this2.notifications[source_mod] = unread;
                var total = 0;
                for (var m in _this2.notifications) {
                  total += _this2.notifications[m];
                }
                _this2.app.browser.addNotificationToId(total, 'saito-header-menu-toggle');
              });
              this.app.connection.on('saito-header-logo-change-request', function (obj) {
                _this2.disableBackButton();
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "resetHeaderLogo",
    value: function resetHeaderLogo() {
      var _this3 = this;
      var logo = document.querySelector('.saito-header-logo-wrapper');
      if (logo) {
        logo.classList.remove('saito-header-logo-back');
        logo.innerHTML = this.app.browser.logoSVG();
        logo.onclick = function (e) {
          navigateWindow(_this3.header_location, 300);
        };
      }
    }
  }, {
    key: "enableBackButton",
    value: function enableBackButton() {
      var _this4 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.back_button_callback = typeof callback === 'function' ? callback : null;
      var logo = document.querySelector('.saito-header-logo-wrapper');
      if (logo) {
        logo.classList.add('saito-header-logo-back');
      }
      if (!document.querySelector('.saito-back-button')) {
        this.app.browser.addElementToSelector("<i class=\"saito-back-button fa-solid fa-arrow-left\"></i>", '.saito-header-logo-wrapper');
      }
      logo = document.querySelector('.saito-header-logo-wrapper');
      if (logo) {
        logo.onclick = function (e) {
          if (_this4.back_button_callback) {
            _this4.back_button_callback(e);
          }
        };
      }
    }
  }, {
    key: "disableBackButton",
    value: function disableBackButton() {
      this.back_button_callback = null;
      this.resetHeaderLogo();
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this$mod;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!(this.mod == null || !document)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              //
              // add SaitoHeader to DOM if required
              //
              if (!document.getElementById('saito-header')) {
                this.app.browser.prependElementToDom(SaitoHeaderTemplate(this.app, this.mod, this.header_class));
              } else {
                this.app.browser.replaceElementById(SaitoHeaderTemplate(this.app, this.mod, this.header_class), 'saito-header');
              }

              //
              // update header logo
              //
              this.resetHeaderLogo();

              //
              // add shortcut
              //
              if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.use_floating_plus) {
                if (!document.getElementById('saito-floating-menu')) {
                  this.app.browser.addElementToDom(FloatingMenu());
                  this.addFloatingMenu();
                }
              }

              //
              // Process the respondTos for apps that install in the Hamburger menu
              //
              this.addHamburgerMenu();

              //
              // render QR code and cryptos
              //
              _context7.n = 2;
              return this.renderCrypto(true);
            case 2:
              _context7.n = 3;
              return this.app.modules.renderInto('.saito-header');
            case 3:
              //
              // insert username
              //
              this.renderUsername();
              this.attachEvents();
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /*******************************************
     *
     * Process and add floating plus menu items
     *
     ********************************************/
  }, {
    key: "addFloatingMenu",
    value: function addFloatingMenu() {
      var this_header = this;
      var index = 0;
      var menu_entries = [];

      //
      // collect menu items from respondTos
      //
      var mods = this.app.modules.respondTo('saito-floating-menu');
      var _iterator = _createForOfIteratorHelper(mods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mod = _step.value;
          var item = mod.respondTo('saito-floating-menu');
          if (item instanceof Array) {
            item.forEach(function (j) {
              if (!j.rank) {
                j.rank = 100;
              }
              menu_entries.push(j);
            });
          }
        }

        // Sort menu items
        //
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var menu_sort = function menu_sort(a, b) {
        if (a.rank < b.rank) {
          return 1;
        }
        if (a.rank > b.rank) {
          return -1;
        }
        return 0;
      };
      menu_entries = menu_entries.sort(menu_sort);

      // Check filters and add HTML
      //
      for (var i = 0; i < menu_entries.length; i++) {
        var j = menu_entries[i];
        var show_me = true;
        var active_mod = this.app.modules.returnActiveModule();
        if (active_mod && typeof j.disallowed_mods != 'undefined') {
          if (j.disallowed_mods.includes(active_mod.slug)) {
            show_me = false;
          }
        }
        if (active_mod && typeof j.allowed_mods != 'undefined') {
          show_me = false;
          if (j.allowed_mods.includes(active_mod.slug)) {
            show_me = true;
          }
        }
        if (show_me) {
          var id = "saito_floating_menu_item_".concat(index);
          this_header.callbacks[index] = j.callback;
          this_header.addFloatingMenuItem(j, id, index);
          index++;
        }
      }
    }
  }, {
    key: "addFloatingMenuItem",
    value: function addFloatingMenuItem(item, id, index) {
      var html = "\n          <div id=\"".concat(id, "\" data-id=\"").concat(index, "\" class=\"saito-floating-menu-item\">\n            <i class=\"").concat(item.icon, "\"></i>\n          </div>\n        ");
      if (item !== null && item !== void 0 && item.is_active) {
        this.app.browser.addElementToSelector(html, '.saito-floating-item-container.main');
      } else {
        this.app.browser.addElementToSelector(html, '.saito-floating-item-container.alt');
      }
    }

    /*******************************************
     *
     * Process and add floating main menu items
     *
     ********************************************/
  }, {
    key: "addHamburgerMenu",
    value: function addHamburgerMenu() {
      var mods = this.app.modules.respondTo('saito-header');
      var index = 0;
      var menu_entries = [];
      var _iterator2 = _createForOfIteratorHelper(mods),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mod1 = _step2.value;
          var item = mod1.respondTo('saito-header');
          if (item instanceof Array) {
            item.forEach(function (j) {
              if (!j.rank) {
                j.rank = 100;
              }
              menu_entries.push(j);
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var menu_sort = function menu_sort(a, b) {
        if (a.rank < b.rank) {
          return -1;
        }
        if (a.rank > b.rank) {
          return 1;
        }
        return 0;
      };
      menu_entries = menu_entries.sort(menu_sort);
      for (var i = 0; i < menu_entries.length; i++) {
        var j = menu_entries[i];
        var show_me = true;
        var active_mod = this.app.modules.returnActiveModule();
        if (active_mod && typeof j.disallowed_mods != 'undefined') {
          if (j.disallowed_mods.includes(active_mod.slug)) {
            show_me = false;
          }
        }
        if (active_mod && typeof j.allowed_mods != 'undefined') {
          show_me = false;
          if (j.allowed_mods.includes(active_mod.slug)) {
            show_me = true;
          }
        }
        if (show_me) {
          var id = "saito_header_menu_item_".concat(index);
          this.callbacks[id] = j.callback;
          this.addMenuItem(j, id);
          index++;
          if (j.event) {
            j.event(id);
          }
        }
      }
      Array.from(document.querySelectorAll('.saito-header-appspace-option.quicklaunch')).forEach(function (elem) {
        if (elem.dataset.navigation) {
          elem.oncontextmenu = function (e) {
            e.preventDefault();
            navigateWindow(elem.dataset.navigation);
          };
        }
      });
    }
  }, {
    key: "addMenuItem",
    value: function addMenuItem(item, id) {
      var keyword = item.type;
      if (!keyword) {
        console.warn('Unclassified responder to saito-header!');
        keyword = 'module';
      }
      if (item.type == 'navigation' || item.type == 'quicklaunch') {
        keyword = 'module';
      }
      var icon = this.renderMenuItemIcon(item, keyword);
      var html = "     \n      <li id=\"".concat(id, "\" data-id=\"").concat(item.text, "\" class=\"saito-header-appspace-option ").concat(item.type, "\" ").concat(item !== null && item !== void 0 && item.navigation ? "data-navigation=\"".concat(item.navigation, "\"") : '', ">\n        ").concat(icon, "\n        <span class=\"saito-menu-item-label\">").concat(item.text, "</span></li>");
      var menu = document.querySelector(".saito-header-menu-section .".concat(keyword, "-menu > ul"));
      if (menu && menu.parentElement) {
        menu.innerHTML += html;
        menu.parentElement.classList.remove('empty-menu-section');
      }
    }
  }, {
    key: "renderMenuItemIcon",
    value: function renderMenuItemIcon(item, keyword) {
      if (keyword === 'module') {
        var icon_paths = this.returnModuleMenuIconPaths(item.text);
        if (icon_paths) {
          return "<span class=\"saito-module-menu-icon-wrap\" aria-hidden=\"true\">\n          <img class=\"saito-module-menu-icon saito-module-menu-icon-outline\" src=\"".concat(icon_paths.outline, "\" alt=\"\">\n          <img class=\"saito-module-menu-icon saito-module-menu-icon-solid\" src=\"").concat(icon_paths.solid, "\" alt=\"\">\n        </span>");
        }
      }
      return "<i class=\"".concat(item.icon, "\"></i>");
    }
  }, {
    key: "returnModuleMenuIconPaths",
    value: function returnModuleMenuIconPaths() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = text.toLowerCase().replace(/[^a-z0-9]/g, '');
      var icons = {
        arcade: 'saito-arcade-icon',
        chat: 'saito-chat-icon',
        filetransfer: 'saito-filetransfer-icon',
        fileshare: 'saito-filetransfer-icon',
        games: 'saito-games-icon',
        redsquare: 'saito-redsquare-icon',
        saitotalk: 'saito-talk-icon',
        store: 'saito-store-icon',
        swarmcast: 'saito-swarmcast-icon',
        talk: 'saito-talk-icon',
        vault: 'saito-vault-icon',
        stack: 'saito-stack-icon',
        rustscript: 'saito-rustscript-icon'
      };
      if (!icons[key]) {
        return null;
      }
      return {
        outline: "/saito/icons/".concat(icons[key], "-outline.svg"),
        solid: "/saito/icons/".concat(icons[key], "-solid.svg")
      };
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this5 = this;
      var app = this.app;
      var mod = this.mod;
      var this_header = this;

      //
      // Open/close sidebar
      //

      if (document.querySelector('#saito-header-menu-toggle')) {
        document.querySelector('#saito-header-menu-toggle').addEventListener('click', function () {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.remove('show-wallet');
          }
          _this5.toggleMenu();
        });
      }
      if (document.querySelector('.saito-header-backdrop')) {
        document.querySelector('.saito-header-backdrop').onclick = function () {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.remove('show-wallet');
          }
          _this5.toggleMenu();
        };
      }

      //
      // default buttons
      //
      if (document.getElementById('wallet-btn-withdraw')) {
        document.getElementById('wallet-btn-withdraw').onclick = function (e) {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.remove('show-wallet');
          }
          app.connection.emit('saito-crypto-withdraw-render-request');
          _this5.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-settings')) {
        document.getElementById('wallet-btn-settings').onclick = function (e) {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.remove('show-wallet');
          }
          app.connection.emit('settings-overlay-render-request');
          _this5.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-switch')) {
        document.getElementById('wallet-btn-switch').onclick = function () {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.toggle('show-wallet');
          }
        };
      }
      if (document.getElementById('wallet-btn-nft')) {
        document.getElementById('wallet-btn-nft').onclick = function () {
          var sidebar = document.querySelector('.saito-header-hamburger-contents');
          if (sidebar) {
            sidebar.classList.remove('show-wallet');
          }
          _this5.app.connection.emit('saito-nft-list-render-request');
          _this5.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-get-saito')) {
        document.getElementById('wallet-btn-get-saito').onclick = function () {
          _this5.app.connection.emit('saito-purchase-launch');
          _this5.hideMenu();
        };
      }
      if (document.getElementById('share-address')) {
        var shareButton = document.getElementById('share-address');
        if (typeof navigator.share !== 'function') {
          shareButton.remove();
        } else {
          shareButton.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
            var _profile_key$dataset;
            var profile_key, address, _t;
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.p = _context8.n) {
                case 0:
                  profile_key = document.getElementById('profile-public-key');
                  address = profile_key === null || profile_key === void 0 || (_profile_key$dataset = profile_key.dataset) === null || _profile_key$dataset === void 0 ? void 0 : _profile_key$dataset.add;
                  if (address) {
                    _context8.n = 1;
                    break;
                  }
                  return _context8.a(2);
                case 1:
                  _context8.p = 1;
                  _context8.n = 2;
                  return navigator.share({
                    text: address
                  });
                case 2:
                  _context8.n = 4;
                  break;
                case 3:
                  _context8.p = 3;
                  _t = _context8.v;
                  if ((_t === null || _t === void 0 ? void 0 : _t.name) !== 'AbortError') {
                    console.error('Unable to share wallet address', _t);
                  }
                case 4:
                  return _context8.a(2);
              }
            }, _callee8, null, [[1, 3]]);
          }));
        }
      }
      var pubkey_container = document.querySelector('.pubkey-container');
      if (pubkey_container) {
        pubkey_container.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
          var _profile_key$dataset2;
          var profile_key, public_key, icon_element;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                profile_key = document.getElementById('profile-public-key');
                public_key = profile_key === null || profile_key === void 0 || (_profile_key$dataset2 = profile_key.dataset) === null || _profile_key$dataset2 === void 0 ? void 0 : _profile_key$dataset2.add;
                if (public_key) {
                  _context9.n = 1;
                  break;
                }
                return _context9.a(2);
              case 1:
                _context9.n = 2;
                return navigator.clipboard.writeText(public_key);
              case 2:
                icon_element = document.querySelector('.pubkey-container i.fa-copy');
                if (icon_element) {
                  _context9.n = 3;
                  break;
                }
                return _context9.a(2);
              case 3:
                icon_element.classList.toggle('fa-copy');
                icon_element.classList.toggle('fa-check');
                setTimeout(function () {
                  icon_element.classList.toggle('fa-copy');
                  icon_element.classList.toggle('fa-check');
                }, 800);
              case 4:
                return _context9.a(2);
            }
          }, _callee9);
        }));
      }
      if (document.getElementById('wallet-select-crypto')) {
        document.getElementById('wallet-select-crypto').onchange = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(e) {
            var ticker, cryptoMod;
            return _regenerator().w(function (_context0) {
              while (1) switch (_context0.n) {
                case 0:
                  ticker = e.target.value;
                  cryptoMod = _this5.app.wallet.returnCryptoModuleByTicker(ticker);
                  if (!cryptoMod.isActivated()) {
                    _this5.app.connection.emit('saito-header-install-crypto', ticker);
                  }
                  _context0.n = 1;
                  return app.wallet.setPreferredCrypto(ticker);
                case 1:
                  clearTimeout(_this5.web3_start_polling_timeout);
                  _this5.app.wallet.returnPreferredCrypto().startPolling();
                  _context0.n = 2;
                  return _this5.renderCrypto(true);
                case 2:
                  return _context0.a(2);
              }
            }, _callee0);
          }));
          return function (_x3) {
            return _ref8.apply(this, arguments);
          };
        }();
      }

      //
      // Apps
      //
      document.querySelectorAll('.saito-header-appspace-option').forEach(function (menu) {
        var id = menu.getAttribute('id');
        var data_id = menu.getAttribute('data-id');
        var callback = this_header.callbacks[id];
        if (typeof callback !== 'function') {
          return;
        }
        menu.addEventListener('click', /*#__PURE__*/function () {
          var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(e) {
            return _regenerator().w(function (_context1) {
              while (1) switch (_context1.n) {
                case 0:
                  _this5.toggleMenu();
                  e.preventDefault();
                  callback(app, data_id);
                case 1:
                  return _context1.a(2);
              }
            }, _callee1);
          }));
          return function (_x4) {
            return _ref9.apply(this, arguments);
          };
        }());
      });

      //
      // Mobile support
      //
      if (document.querySelector('#saito-floating-plus-btn')) {
        document.getElementById('saito-floating-plus-btn').onclick = function (e) {
          var floating_menu = document.getElementById('saito-floating-menu');
          if (floating_menu) {
            floating_menu.classList.toggle('activated');
          }
        };
      }
      if (document.getElementById('saito-floating-menu-mask')) {
        document.getElementById('saito-floating-menu-mask').onclick = function (e) {
          var floating_menu = document.getElementById('saito-floating-menu');
          if (floating_menu) {
            floating_menu.classList.toggle('activated');
          }
        };
      }
      document.querySelectorAll('.saito-floating-menu-item').forEach(function (menu) {
        var id = menu.getAttribute('id');
        var data_id = menu.getAttribute('data-id');
        var callback = this_header.callbacks[data_id];
        menu.onclick = function (e) {
          e.preventDefault();
          if (typeof callback === 'function') {
            callback(this_header.app, data_id);
          }
          var floating_menu = document.getElementById('saito-floating-menu');
          if (floating_menu) {
            floating_menu.classList.toggle('activated');
          }
        };
      });
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var sidebar = document.querySelector('.saito-header-hamburger-contents');
      if (!sidebar) {
        return;
      }
      if (sidebar.classList.contains('show-menu')) {
        this.hideMenu();
      } else {
        this.openMenu();
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      var _this6 = this;
      var sidebar = document.querySelector('.saito-header-hamburger-contents');
      var backdrop = document.querySelector('.saito-header-backdrop');
      if (!sidebar || !backdrop) {
        return;
      }
      if (!sidebar.classList.contains('show-menu')) {
        sidebar.classList.add('show-menu');
        backdrop.classList.add('menu-visible');
        window.dispatchEvent(new CustomEvent('saito-header-menu-state', {
          detail: {
            open: true
          }
        }));

        //
        // start polling web3 crypto
        //
        if (this.web3_start_polling_timeout) {
          clearTimeout(this.web3_start_polling_timeout);
          this.web3_start_polling_timeout = null;
        }

        //
        // after 10 seconds, query to update web3 balance if active
        //
        this.web3_start_polling_timeout = setTimeout(function () {
          var _document$querySelect;
          _this6.web3_start_polling_timeout = null;
          if (!((_document$querySelect = document.querySelector('.saito-header-hamburger-contents')) !== null && _document$querySelect !== void 0 && _document$querySelect.classList.contains('show-menu'))) {
            return;
          }
          var c = _this6.app.wallet.returnPreferredCrypto();
          if (!c || c.categories === 'NFT') {
            return;
          }
          if (typeof c.startPolling === 'function') {
            c.startPolling();
          }
        }, 10000);
      }
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      var _this$app, _this$app$returnPrefe;
      var sidebar = document.querySelector('.saito-header-hamburger-contents');
      if (!sidebar) {
        return;
      }
      sidebar.classList.remove('show-wallet');
      var backdrop = document.querySelector('.saito-header-backdrop');
      if (sidebar.classList.contains('show-menu')) {
        sidebar.classList.remove('show-menu');
        if (backdrop) {
          backdrop.classList.remove('menu-visible');
        }
      }
      window.dispatchEvent(new CustomEvent('saito-header-menu-state', {
        detail: {
          open: false
        }
      }));

      //
      // clear web3 polling if active
      //
      if (this.web3_start_polling_timeout) {
        clearTimeout(this.web3_start_polling_timeout);
        this.web3_start_polling_timeout = null;
      }
      var preferred = (_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.wallet) === null || _this$app === void 0 || (_this$app$returnPrefe = _this$app.returnPreferredCrypto) === null || _this$app$returnPrefe === void 0 ? void 0 : _this$app$returnPrefe.call(_this$app);
      if (preferred && typeof preferred.stopPolling === 'function') {
        preferred.stopPolling();
      }
    }

    /****************************************************
     *
     * A pair of functions to update the user name field in the header
     * and attach click functionality.
     *
     ***************************************************/
  }, {
    key: "updateHeaderMessage",
    value: function updateHeaderMessage() {
      var _this7 = this;
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var flash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var this_self = this;
      var el = document.getElementById('header-msg');
      if (!el) {
        return;
      }
      if (text == '') {
        this.renderUsername();
        el = document.getElementById('header-msg');
        if (!el) {
          return;
        }
      } else {
        el.onmouseenter = null;
        el.onmouseleave = null;
        el.innerHTML = text;
      }
      if (flash) {
        el.classList.add('flash');
      } else {
        el.classList.remove('flash');
      }
      if (callback != null) {
        if (timeout) {
          setTimeout(function () {
            this_self.updateHeaderMessage();
          }, timeout);
        }

        //
        // Always click once to clear...
        //
        el.onclick = function () {
          delete _this7.app.options.wallet.backup_required;
          _this7.updateHeaderMessage();
          callback();
        };
      }
    }
  }, {
    key: "renderUsername",
    value: function renderUsername() {
      var _this$app$options$wal,
        _this$app$options$wal2,
        _this8 = this;
      var header_self = this;
      var key = this.app.keychain.returnKey(this.publicKey);
      var username = key !== null && key !== void 0 && key.identifier ? key.identifier : this.app.keychain.returnIdentifierByPublicKey(this.publicKey, true);
      if (username == '' || username == this.publicKey) {
        if (this.app.browser.isMobileBrowser()) {
          username = 'Anonymous';
        } else {
          username = 'Anonymous Account';
        }
        if (key !== null && key !== void 0 && key.has_registered_username) {
          username = 'registering...';
        }
      }
      var el = document.getElementById('header-msg');
      if (!el) {
        return;
      }

      //Update name
      el.innerHTML = sanitize(username);
      el.classList.remove('flash');
      el.onmouseenter = null;
      el.onmouseleave = null;
      if (username === 'Anonymous Account') {
        el.onmouseenter = function () {
          el.textContent = 'Register Name';
        };
        el.onmouseleave = function () {
          el.textContent = username;
        };
      }

      //Differential behavior
      if (username === 'Anonymous Account' || username === 'Anonymous') {
        el.onclick = function (e) {
          header_self.app.connection.emit('register-username-or-login', {
            // this gets saved to be called *not* when we submit the name, but when we receive
            // the onchain confirmation
            success_callback: function success_callback(desired_identifier) {
              header_self.app.connection.emit('saito-backup-render-request', {
                msg: "'".concat(desired_identifier, "' succesfully registered, back up now to protect your account")
              });
            }
          });
        };
      } else if (username == 'registering...') {
        el.onclick = null;
      } else {
        if (key !== null && key !== void 0 && key.email) {
          //Launch profile
          el.onclick = function (e) {
            header_self.userMenu.render();
          };
        } else {
          //Prompt email registration
          el.onclick = function (e) {
            header_self.app.connection.emit('recovery-backup-overlay-render-request');
          };
        }
      }
      console.log('Saito-header renderUsername backup_required? ', (_this$app$options$wal = this.app.options.wallet) === null || _this$app$options$wal === void 0 ? void 0 : _this$app$options$wal.backup_required);
      if ((_this$app$options$wal2 = this.app.options.wallet) !== null && _this$app$options$wal2 !== void 0 && _this$app$options$wal2.backup_required) {
        // Display the (updated) user name for a few seconds before restoring the flashing warning
        setTimeout(function () {
          var _this8$app$options$wa;
          // Make sure still needed!
          if ((_this8$app$options$wa = _this8.app.options.wallet) !== null && _this8$app$options$wa !== void 0 && _this8$app$options$wa.backup_required) {
            // Backwards compatibility
            if (_this8.app.options.wallet.backup_required == 1) {
              _this8.app.options.wallet.backup_required = "Have you backed up your wallet recently? Keep your keys and account safe by backing up";
            }
            console.log('Restore flashing reminder from saito-header');
            _this8.updateHeaderMessage('wallet backup required', true, function () {
              _this8.app.connection.emit('saito-backup-render-request', {
                msg: _this8.app.options.wallet.backup_required,
                title: 'BACKUP YOUR WALLET'
              });
            });
          }
        }, 4500);
      }
    }

    /********************************************************
     * ******************************************************
     *
     * Integrate Saito MultiWallet
     *
     * *******************************************************
     *
     * We need to be very careful about what goes in here because this is called * A LOT *
     *
     * on-transaction-pending / on-payment-sent / on-payment-received
     *
     * (previously, on-wallet-update)
     *
     * So if there is something in here that awaits a remote API call, it can be very costly
     *
     * *******************************************************/
  }, {
    key: "renderCrypto",
    value: function () {
      var _renderCrypto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _this9 = this;
        var force,
          available_cryptos,
          preferred_crypto,
          add,
          get_saito_link,
          addressContainer,
          _addressContainer$dat,
          qrcode,
          b_elm,
          cached_balance,
          cryptoSelect,
          ab,
          pb,
          menu_html,
          i,
          crypto_mod,
          is_activated,
          rtn_val,
          logo_src,
          sublogo_src,
          _args11 = arguments,
          _t2;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              force = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : false;
              if (document.getElementById('saito-header')) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              available_cryptos = this.app.wallet.returnInstalledCryptos();
              preferred_crypto = this.app.wallet.returnPreferredCrypto();
              add = preferred_crypto.returnAddress();
              _context11.p = 2;
              get_saito_link = document.querySelector('#wallet-btn-get-saito');
              get_saito_link === null || get_saito_link === void 0 || get_saito_link.classList.toggle('show-get-saito', preferred_crypto.ticker.toUpperCase() === 'SAITO');

              //
              // insert address and qrcode
              //
              addressContainer = document.querySelector('#profile-public-key');
              if (add && addressContainer) {
                if (((_addressContainer$dat = addressContainer.dataset) === null || _addressContainer$dat === void 0 ? void 0 : _addressContainer$dat.add) != add || force) {
                  if (addressContainer.classList.contains('generate-keys')) {
                    addressContainer.classList.remove('generate-keys');
                  }
                  addressContainer.dataset.add = add;
                  addressContainer.textContent = add;
                  qrcode = document.querySelector('#qrcode');
                  if (qrcode) {
                    qrcode.style.visibility = 'hidden';
                    qrcode.style.opacity = '0';
                    qrcode.innerHTML = '';
                    this.app.browser.generateQRCode(add, 'qrcode');
                    setTimeout(function () {
                      qrcode.removeAttribute('style');
                    }, 100);
                  }
                }
              }
              b_elm = document.querySelector('.balance-amount');
              if (b_elm) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2);
            case 3:
              cached_balance = preferred_crypto.balance;
              b_elm.innerHTML = this.app.browser.returnBalanceHTML(cached_balance);
              cryptoSelect = document.querySelector('.wallet-select-crypto');
              if (cryptoSelect) {
                cryptoSelect.innerHTML = available_cryptos.map(function (cryptoMod) {
                  return "<option ".concat(cryptoMod.ticker === preferred_crypto.ticker ? 'selected' : '', " value=\"").concat(cryptoMod.ticker, "\">").concat(cryptoMod.ticker, "</option>");
                }).join('');
              }
              _context11.n = 4;
              return preferred_crypto.getAvailableBalance();
            case 4:
              ab = _context11.v;
              _context11.n = 5;
              return preferred_crypto.getPendingBalance();
            case 5:
              pb = _context11.v;
              //
              // insert crypto balance
              //
              try {
                if (preferred_crypto.isActivated()) {
                  if (preferred_crypto.categories === 'NFT') {
                    if (pb !== ab) {
                      b_elm.classList.add('pending');
                      b_elm.innerHTML = "<span class=\"balance-amount-whole\">".concat(pb, "</span>");
                    } else {
                      b_elm.classList.remove('pending');
                      b_elm.innerHTML = "<span class=\"balance-amount-whole\">".concat(ab, "</span>");
                    }
                  } else if (pb !== ab) {
                    b_elm.classList.add('pending');
                    b_elm.innerHTML = this.app.browser.returnBalanceHTML(pb);
                  } else {
                    b_elm.classList.remove('pending');
                    b_elm.innerHTML = this.app.browser.returnBalanceHTML(ab);
                  }
                }
              } catch (err) {
                console.error('Error rendering crypto balance: ' + err);
              }
              menu_html = '';
              i = 0;
            case 6:
              if (!(i < available_cryptos.length)) {
                _context11.n = 12;
                break;
              }
              //
              // get cryptos available
              //
              crypto_mod = available_cryptos[i];
              is_activated = crypto_mod.isActivated(); //
              // mixin handles logos
              //
              rtn_val = crypto_mod.returnLogos();
              logo_src = rtn_val.img;
              sublogo_src = rtn_val.sub_logo;
              if (!crypto_mod.ticker) {
                _context11.n = 11;
                break;
              }
              if (!is_activated) {
                _context11.n = 9;
                break;
              }
              _context11.n = 7;
              return crypto_mod.getPendingBalance();
            case 7:
              pb = _context11.v;
              _context11.n = 8;
              return crypto_mod.getAvailableBalance();
            case 8:
              ab = _context11.v;
              _context11.n = 10;
              break;
            case 9:
              pb = ab = '0';
            case 10:
              menu_html += "<div class=\"saito-header-crypto ".concat(is_activated ? 'active' : 'inactive', " ").concat(crypto_mod.ticker === preferred_crypto.ticker ? 'selected' : '', "\" data-ticker=\"").concat(crypto_mod.ticker, "\">");
              menu_html += "<div class=\"crypto-logo-container\"><img class=\"crypto-logo\" src=\"".concat(logo_src, "\">");
              if (sublogo_src) {
                menu_html += "<img class=\"chain-logo\" src=\"".concat(sublogo_src, "\">");
              }
              menu_html += "</div><div class=\"header-crypto-balance\">".concat(this.app.browser.formatDecimals(ab), " ").concat(crypto_mod.ticker, "</div>");
              if (is_activated && Number(pb) != Number(ab)) {
                menu_html += "<div class=\"header-crypto-pending\">".concat(this.app.browser.formatDecimals(pb), " pending </div>");
              } else {
                menu_html += '<div></div>';
              }
              if (is_activated) {
                menu_html += "\n              <div\n                class=\"saito-icon-button header-crypto-history\"\n                data-ticker=\"".concat(crypto_mod.ticker, "\"\n                title=\"View ").concat(crypto_mod.ticker, " recent transactions\"\n                aria-label=\"View ").concat(crypto_mod.ticker, " recent transactions\"\n                role=\"button\"\n                tabindex=\"0\"\n              >\n                <i class=\"fa-solid fa-clock-rotate-left\" aria-hidden=\"true\"></i>\n              </div>\n            ");
              }
              menu_html += "</div>";
            case 11:
              i++;
              _context11.n = 6;
              break;
            case 12:
              this.app.browser.replaceElementBySelector("<div class=\"saito-header-wallet-menu saito-menu-select-subtle\">".concat(menu_html, "</div>"), '.saito-header-wallet-menu');
              _context11.n = 14;
              break;
            case 13:
              _context11.p = 13;
              _t2 = _context11.v;
              console.error('Error rendering crypto selector: ' + _t2);
            case 14:
              //
              //
              //
              Array.from(document.querySelectorAll('.saito-header-crypto')).forEach(function (c) {
                c.onclick = /*#__PURE__*/function () {
                  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(e) {
                    var ticker, cryptoMod, preferredCrypto, sidebar;
                    return _regenerator().w(function (_context10) {
                      while (1) switch (_context10.n) {
                        case 0:
                          ticker = e.currentTarget.dataset.ticker;
                          cryptoMod = _this9.app.wallet.returnCryptoModuleByTicker(ticker);
                          if (!cryptoMod.isActivated()) {
                            _this9.app.connection.emit('saito-header-install-crypto', ticker);
                          }
                          _context10.n = 1;
                          return _this9.app.wallet.setPreferredCrypto(ticker);
                        case 1:
                          clearTimeout(_this9.web3_start_polling_timeout);
                          preferredCrypto = _this9.app.wallet.returnPreferredCrypto();
                          if (preferredCrypto && typeof preferredCrypto.startPolling === 'function') {
                            preferredCrypto.startPolling();
                          }
                          sidebar = document.querySelector('.saito-header-hamburger-contents');
                          if (sidebar) {
                            sidebar.classList.remove('show-wallet');
                          }
                          _context10.n = 2;
                          return _this9.renderCrypto(true);
                        case 2:
                          return _context10.a(2);
                      }
                    }, _callee10);
                  }));
                  return function (_x5) {
                    return _ref0.apply(this, arguments);
                  };
                }();
              });
              Array.from(document.querySelectorAll('.header-crypto-history')).forEach(function (button) {
                var openHistory = function openHistory(e) {
                  e.stopPropagation();
                  _this9.app.connection.emit('saito-crypto-wallet-history-render-request', {
                    ticker: e.currentTarget.dataset.ticker
                  });
                  _this9.hideMenu();
                };
                button.onclick = openHistory;
                button.onkeydown = function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openHistory(e);
                  }
                };
              });
            case 15:
              return _context11.a(2);
          }
        }, _callee11, this, [[2, 13]]);
      }));
      function renderCrypto() {
        return _renderCrypto.apply(this, arguments);
      }
      return renderCrypto;
    }()
  }]);
}(UIModTemplate);
module.exports = SaitoHeader;